import { create } from 'zustand';

const useStore = create((set, get) => ({
  // Global configuration
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  imagesBaseUrl: process.env.REACT_APP_IMAGES_BASE_URL,

  // Language settings
  currentLanguage: 'en',
  availableLanguages: [
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'hi', name: 'Hindi', nativeName: 'हिंदी' },
    { code: 'bn', name: 'Bengali', nativeName: 'বাংলা' },
    { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
    { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' },
    { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
    { code: 'ml', name: 'Malayalam', nativeName: 'മലയാളം' },
    { code: 'gu', name: 'Gujarati', nativeName: 'ગુજરાતી' },
    { code: 'mr', name: 'Marathi', nativeName: 'मराठी' },
    { code: 'pa', name: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ' },
    { code: 'or', name: 'Odia', nativeName: 'ଓଡ଼ିଆ' },
    { code: 'as', name: 'Assamese', nativeName: 'অসমীয়া' }
  ],

  // Authentication state
  authToken: localStorage.getItem('authToken'),
  isAuthenticated: !!localStorage.getItem('authToken'),
  userRole: localStorage.getItem('userRole') || 'admin',
  userFullName: localStorage.getItem('userFullName') || '',

  // Current crop data
  currentCrop: null,
  loading: false,
  error: null,

  // Actions
  setLanguage: (language) => set({ currentLanguage: language }),

  setAuth: (token, role, fullName) => {
    localStorage.setItem('authToken', token);
    localStorage.setItem('userRole', role || 'admin');
    localStorage.setItem('userFullName', fullName || '');
    set({
      authToken: token,
      isAuthenticated: !!token,
      userRole: role || 'admin',
      userFullName: fullName || ''
    });
  },

  logout: () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userFullName');
    set({
      authToken: null,
      isAuthenticated: false,
      userRole: 'admin',
      userFullName: ''
    });
  },

  setCurrentCrop: (crop) => set({ currentCrop: crop }),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),

  // Helper to get image URL
  getImageUrl: (imageName) => {
    if (!imageName) return null;
    return `${get().imagesBaseUrl}/${imageName}`;
  },

  // Helper to get API URL
  getApiUrl: (endpoint) => {
    return `${get().apiBaseUrl}${endpoint}`;
  }
}));

export default useStore;